/**
 *
 * LogoutPage
 *
 */
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { clearAdminSession } from '../../../utils/auth/adminPermissions';

interface Props {}

export function LogoutPage(props: Props) {
  const history = useHistory();
  clearAdminSession();
  history.push('/login');
  return <p>Logout</p>;
}
